module.exports = __webpack_public_path__ + "static/media/empty_avatar.1bdab980.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/users/empty_avatar.jpg
// module id = 1586
// module chunks = 0